import React, { memo, useRef, useEffect } from 'react'
import lottie from 'lottie-web'

import animateLogo from 'assets/logo.json'

const LogoAnimated = ({ className = '' }) => {
  const logoRef = useRef()

  useEffect(() => {
    lottie.loadAnimation({
      container: logoRef.current, // the dom element that will contain the animation: ;
      //renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: animateLogo,
    })
  }, [])

  return <div className={`logo_animated ${className}`} ref={logoRef} />
}

export default memo(LogoAnimated)
